var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "recommend" }, [
    _c(
      "div",
      [
        _c(
          "v-tabs",
          {
            attrs: {
              "next-icon": "mdi-arrow-right-bold-box-outline",
              "prev-icon": "mdi-arrow-left-bold-box-outline",
              "show-arrows": "",
            },
            model: {
              value: _vm.tab,
              callback: function ($$v) {
                _vm.tab = $$v
              },
              expression: "tab",
            },
          },
          [
            _c("v-tabs-slider"),
            _vm._v(" "),
            _vm._l(_vm.items, function (item) {
              return _c("v-tab", [
                _c("span", [
                  _vm._v(
                    "\n                       " +
                      _vm._s(item.label) +
                      "\n                "
                  ),
                ]),
              ])
            }),
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "v-tabs-items",
          {
            model: {
              value: _vm.tab,
              callback: function ($$v) {
                _vm.tab = $$v
              },
              expression: "tab",
            },
          },
          _vm._l(_vm.items, function (item) {
            return _c(
              "v-tab-item",
              [
                _c("v-card", { attrs: { flat: "" } }, [
                  _c("div", { staticClass: "recommend__content" }, [
                    _c("div", { staticClass: "recommend__img" }, [
                      _c("img", { attrs: { src: item.src, alt: "" } }),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "recommend__descr" },
                      [
                        _vm._l(item.features, function (feature, id) {
                          return _c(
                            "div",
                            { key: id, staticClass: "recommend__features" },
                            [
                              _c("div", { staticClass: "recommend__feature" }, [
                                _c("img", {
                                  attrs: { src: feature.url, alt: "" },
                                }),
                                _vm._v(" "),
                                _c("div", [_vm._v(_vm._s(feature.name))]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "recommend__characteristic" },
                                [_vm._v(_vm._s(feature.characteristic))]
                              ),
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "recommend__btn btn-red ",
                            attrs: { href: item.url },
                          },
                          [_vm._v("Подробнее")]
                        ),
                      ],
                      2
                    ),
                  ]),
                ]),
              ],
              1
            )
          }),
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }